// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3g4I8","requiredAsterisk":"Info_requiredAsterisk__3uMAZ"};